/*
  Izvoz seznama tečajnikov za Excel.

  Slovenski Excel pričakuje podpičje kot ločilo in BOM na začetku, sicer
  šumnike prikaže kot smeti in vse stlači v en stolpec.
*/

import { fmtDate, today } from './format.js';

const HEAD = [
  'Št.',
  'Ime',
  'Priimek',
  'Datum rojstva',
  'Kraj rojstva',
  'Naslov',
  'Pošta',
  'Telefon',
  'Email',
  'Datum tečaja',
  'Plačano',
  'Teorija',
  'Status',
];

/**
 * Ubeži eno celico.
 *
 * Vrednost, ki se začne z = + - @, je za Excel formula. Zato ji dodamo
 * apostrof: telefonska „+386 40 …“ sicer sproži opozorilo, v najslabšem
 * primeru pa se izvede kot formula (CSV injection).
 */
export function escapeCell(v) {
  let t = v == null ? '' : String(v);
  if (/^[=+\-@\t\r]/.test(t)) t = "'" + t;
  return /[";\n\r]/.test(t) ? `"${t.replace(/"/g, '""')}"` : t;
}

export function buildStudentsCSV(users) {
  const rows = users
    .filter((u) => u.stevilka != null)
    .sort((a, b) => a.stevilka - b.stevilka)
    .map((u) => [
      u.stevilka,
      u.ime,
      u.priimek,
      fmtDate(u.datum_rojstva),
      u.kraj_rojstva,
      u.naslov,
      u.posta,
      u.telefon,
      u.email,
      fmtDate(u.datum_tecaja),
      u.placano ? 'da' : 'ne',
      u.teorija_datum ? fmtDate(u.teorija_datum) : 'ne',
      u.archived ? 'arhiv' : 'aktiven',
    ]);

  return [HEAD, ...rows].map((r) => r.map(escapeCell).join(';')).join('\r\n');
}

/** Sproži prenos datoteke v brskalniku. */
export function downloadCSV(users) {
  const blob = new Blob(['﻿' + buildStudentsCSV(users)], {
    type: 'text/csv;charset=utf-8',
  });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = `perut-tecajniki-${today()}.csv`;
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 1000);
  return users.filter((u) => u.stevilka != null).length;
}
